import styles from './LocationPanel.module.css'
import classNames from 'classnames'
import { SearchIcon2 } from 'shared/icons'
import { LocationAutoCompleteInput } from 'shared/widgets/LocationAutoCompleteInput2'
import { locationToString } from 'shared/lib/locationToString'
import { useMemo, useRef } from 'react'
import { LocationAutoCompleteInputContainer } from 'shared/containers/LocationAutoCompleteInputContainer/LocationAutoCompleteInputContainer'
import { LocationSearchHistory } from '../LocationSearchHistory'

interface LocationPanellProps {
    expanded: boolean
    searchString?: string
    className?: string
    location?: any
    onSummaryClick?: (event: any) => void
    onLocationSearchStringChange: (event: any) => void
    onLocationChange: (event: any) => void
}

export const LocationPanel = (props: LocationPanellProps): JSX.Element => {
    const {
        expanded = false,
        className,
        location,
        searchString = ``,
        onSummaryClick,
        onLocationSearchStringChange,
        onLocationChange
    } = props

    const locationAutoCompleteInputRef = useRef<any>(null)

    const handleButtonClick = (event: any) => {
        onSummaryClick?.(event)
    }

    const spyLaunchSettingsPanelClasses= classNames(styles.SpyLaunchSettingsPanel, className, {
        [styles[`SpyLaunchSettingsPanel--Expanded`]]: expanded,
    })

    const spyLaunchSettingsButtonClasses = classNames(styles.SpyLaunchSettingsButton, className, {
        [styles[`SpyLaunchSettingsButton--Active`]]: expanded,
        [styles[`SpyLaunchSettingsButton--HasValue`]]: location !== undefined
    })

    const LocationPanelDetailsClasses = classNames(styles.LocationPanel__Details, {
        [styles[`LocationPanel__Details--Expanded`]]: expanded,
    })

    const renderValue = (): JSX.Element => {
        if (location === undefined){
            return (
                <></>
            )
        }

        const valueString = locationToString(location)

        return (
            <span className={styles.SpyLaunchSettingsButton__ValueContainer}>
                <span className={styles.SpyLaunchSettingsButton__ValueCaption}>
                    {valueString}
                </span>
            </span>
        )
    }
    
    const handleLocationSearchHistoryItemSelect = (event: any) => {
        onLocationChange?.(event)
    }

    const handleLocationAutoCompleteInputContainerInput = (event: any) => {
        onLocationSearchStringChange?.(event)
    }

    const handleLocationAutoCompleteInputContainerLocationChange = (event: any) => {
        onLocationChange?.(event)
    }

    const hasValue = location!== undefined
    const heading = useMemo(() => {
            if (hasValue){
                return `Location`
            }
    
            return 'Select Location'
        }, [
            location
    ])

    return (
        <div className={spyLaunchSettingsPanelClasses}>
            <div 
                className={styles.SpyLaunchSettingsPanel__Summary}             
            >
                <button
                    className={spyLaunchSettingsButtonClasses}  
                    onClick={handleButtonClick}           
                >
                    <span className={styles.SpyLaunchSettingsButton__HelperContainer}>
                        <span className={styles.SpyLaunchSettingsButton__IconContainer}>
                            <SearchIcon2
                                className={styles.LocationPanel__SummaryIcon}
                            />
                        </span>
                        <span className={styles.SpyLaunchSettingsButton__Caption}>
                           {heading}
                        </span>               
                    </span>
                    {
                        renderValue()
                    }
                </button>
            </div>
            <div className={LocationPanelDetailsClasses}>
                <div className={styles.LocationPanel__LocationAutoCompleteInputContainer}>
                    <LocationAutoCompleteInputContainer
                        location={location}
                        text={searchString}
                        ref={locationAutoCompleteInputRef}
                        onInput={handleLocationAutoCompleteInputContainerInput}
                        onLocationChange={handleLocationAutoCompleteInputContainerLocationChange}
                        // text={locationString}
                        // options={locationOptions}
                        // ref={searchButtonRef}
                        // isLoading={locationOptionsIsLoading}
                        // isOptionsOpen={locationOptionsIsOpen}
                        // onInput={handleAutocompleteInputInput}
                        // onOptionClick={handleAutocompleteInputOptionClick}
                    />
                </div>     
                    {/* 
                        <div className={styles.Dialog__NearbyContainer}>
                            <NearbyButton
                                className={styles.Dialog__NearbyButton}
                                onClick={handleNearbyButtonClick}
                            />
                        </div>   
                    */}
                <div className={styles.LocationPanel__HistoryContainer}>
                    <LocationSearchHistory 
                        onHistoryItemSelect={handleLocationSearchHistoryItemSelect}
                    />       
                </div>
            </div>
        </div>
    )
}